import project from '@/api/project-mgt/project-profile'
import attachment from '@/api/project-mgt/module-attchment'

import { baseState, baseMutations } from '@/store/mixins'

const getItem = key => {
  var item = localStorage.getItem(key)
  return JSON.parse(item)
}

export const state = {
  ...baseState,
  only_my_project:
    getItem('only_my_project') == null ? true : getItem('only_my_project'),
  involve_project: getItem('involve_project'),
  created_by_me: getItem('created_by_me_project'),
  statusId: getItem('status_project') !== null ? getItem('status_project') : []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_MY_PROJECT_FILTER(state, value) {
    localStorage.setItem('only_my_project', JSON.stringify(value))
    state.only_my_task = value
  },
  SET_INVOLVE_PROJECT_FILTER(state, value) {
    localStorage.setItem('involve_project', JSON.stringify(value))
    state.involve_task = value
  },
  SET_CREATED_BY_ME_FILTER(state, value) {
    localStorage.setItem('created_by_me_project', JSON.stringify(value))
    state.created_by_me = value
  },
  SET_STATUS_FILTER(state, value) {
    localStorage.setItem('status_project', JSON.stringify(value))
    state.statusId = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return project.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return project.store(data)
  },
  update(context, { id, data }) {
    return project.update(id, data)
  },
  updateMember(context, { id, data }) {
    return project.updateMember(id, data)
  },
  destroy(context, id) {
    return project.destroy(id)
  },
  find(context, id) {
    return project.find(id)
  },
  formViewModel(context, attrubutes = {}) {
    return project.formViewModel({ params: attrubutes })
  },
  getTask(context, params) {
    return project.getTask({ params })
  },
  history(context, attrubutes = {}) {
    return project.history({ params: attrubutes })
  },
  attachFile(context, data) {
    return attachment.store(data)
  },
  deleteAttachment(context, id) {
    return attachment.destroy(id)
  }
}
